import { FolderDto, GalleryDto } from '@nusign/picflow-backend-types';

export const IsGallery = (gallery: GalleryDto | FolderDto) => {
  return gallery.id.startsWith('gal_');
};
